<template>
	<div class="container-large mt-5 px-3">
		<div class="col-md-6 offset-md-3 mb-5 px-0"
			v-if="!is_home">
			<button class="px-5 btn-previous btn btn-light"
				@click="Previous">
				<i class="fal fa-chevron-left px-2"></i>
			</button>
		</div>
		
		<transition-group name="fade" mode="out-in">
			<div v-if="search.length > 2"
				class="search-matches-container"
				key="search-matches-container"
			>
				<div class="w-100 my-5 mx-auto sections-container">
					<h4 class="text-uppercase">Resultado da pesquisa - {{ search }}</h4>
					<ul class="list-container"
						v-if="articles.length > 0">
						<li v-for="article in articles"
							:key="article.id">
							<router-link
								v-if="article.category && article.section"
								:to="{ name: 'Article', params: {
									category_slug: article.category.slug,
									section_slug: article.section.slug,
									article_slug: article.slug
								}}">
								{{ article.titulo }}
							</router-link>
						</li>
					</ul>
					<small v-if="quantity != null">Quantidade de artigos encontrados: <b>{{ quantity }}</b></small>
				</div>
			</div>
			<div v-else class="home-container" key="home-container">
				<Categories key="categories" />

				<div class="col-12 my-5 d-flex justify-content-center mx-auto" key="fa">
					<div class="fa-container">
						<h4 class="text-uppercase">Perguntas Frequentes</h4>
						<ul class="list-container">
							<li v-for="section in fa_sections"
								:key="section.id">
								<router-link
									class="col-12"
									:to="{ name: 'Section', params: {
										category_slug: 'perguntas-frequentes',
										section_slug: section.slug
									}}">
									{{ section.descricao }}
								</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</transition-group>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'
    import Categories from './../categories/Categories'

	import _ from 'lodash'

	export default {
		name: 'Index',
        components: {
            Categories
        },
		props: {
			props_search: {
				type: 		String,
				default:	''
			},
			articles_data:		{
				type: 		Object,
				default:	() => {}
			}
		},
		data () {
			return {
				articles:	[],
				quantity:	null,
				search:		"",
			}
		},
		computed: {
			...mapGetters('system', [
				'sections'
			]),
			fa_sections() {
				return this.sections.filter(s => s.faq_category_id === 1)
			},
			is_home() {
				return this.$route.name == 'Home'
			}
		},
		watch: {
			props_search: {
				handler(val) {
					this.search = val
				},
				immediate: true
			},
			articles_data: {
				handler(val) {
					if(!_.isEmpty(val)) {
						this.articles = val.articles
						this.quantity = val.quantity
					}
				},
				immediate: true,
				deep: true
			}
		},
		methods: {
			...mapActions('system', [
				'GetSections'
			]),
		},
		beforeMount() {
			this.search = ''

			this.GetSections()
		}
	}
</script>

<style lang="css" scoped>
.fa-container {
	width: 100%;
}

@media (min-width: 1200px) {
    .fa-container {
        width: 900px;
    }
}
</style>